import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { branch } from 'baobab-react/higher-order';
import Link from '../common/TrackedLink';
import Breadcrumb from '../common/Breadcrumb';
import BreadcrumbItem from '../common/BreadcrumbItem';

import Hero from './common/Hero';
import TrustedSection from './common/TrustedSection';
import TopProducts from './common/TopProducts';
import Testimonial from './common/Testimonial';
import TotalProductCount from './common/TotalProductCount';
// import OptInPopup from "../components/OptInPopup";
import config from "../../config";
import {buildEcomProductArrayForTopProducts, pushNewEcommerceEvent} from "../../utils/datalayer";
import InView from "../common/InView";

class Category extends Component {
	constructor(props) {
		super(props);
		this.handleTopProductsInview = this.handleTopProductsInview.bind(this);
	}
	handleTopProductsInview() {
		const {featuredProduct} = this.props;
		const items = buildEcomProductArrayForTopProducts(featuredProduct, 'Document Safes');
		pushNewEcommerceEvent('view_item_list', items);
	}
	render() {
		const pageTitle = 'Document Safes';
		const totalCount = this.props.category.productCount;
		let topProducts;
		// eslint-disable-next-line eqeqeq
		if (this.props.featuredProduct != null) {
			topProducts = (
				<InView onInView={this.handleTopProductsInview}>
					<TopProducts
						title={ `Best Selling ${pageTitle}` }
						subTitle="Keep important documents safe and organized"
						path="document-safes"
						buttonCTA={ `View all ${pageTitle}` }
						topProduct={ this.props.featuredProduct }
					/>
				</InView>
			);
		}
		
		return (
			<div className="category category-document">
				<Helmet defer={false}>
					<title>{ pageTitle } &#124; SentrySafe</title>
					<meta name="description" content="Our document safes keep your important paperwork and personal items organized and protected. View document safes." />
					<script async src={config.bazaarVoiceScriptUrl} />
				</Helmet>

				<Breadcrumb>
					<BreadcrumbItem path="/products" label="Products" />
					<BreadcrumbItem label={ pageTitle } />
				</Breadcrumb>

				<Hero
					imageSrc={ require('../../resources/img/hero/document-safes.jpg') }
					imageAlt="Man and woman reviewing documents"
					title={ pageTitle }
					description="Safe storage for the things that matter."
				/>
				
				<TrustedSection
					content="Throughout our lives, there are moments that change us forever. Getting married, the birth of a child, moving into a new home, and more. SentrySafe knows that along with those moments come keepsakes you cherish and important financial documents you need to save. SentrySafe Document Safes keep your paperwork and personal items organized and protected from peril."
				/>

				{ topProducts }

				<section className="row certification">
					<div className="col">
						<h2 className="title">Peril Protection</h2>
					</div>
					<div className="row">
						<div className="col sm-6">
							<div className="icon">
								<img
									src={ require('../../resources/img/icons/UL-logo.png') }
									alt="UL Fire Endurance"
								/>
							</div>
							<h3>Fire Resistant</h3>
							<p>UL Fire Endurance testing keeps interior temperatures below 350 F &#40;177 C&#41; for up to 30 minutes.</p>
							<Link to="/learn/buying-guide" className="arrow-link">
								Learn more about UL testing
							</Link>
						</div>
						<div className="col sm-6">
							<div className="icon">
								<img
									src={ require('../../resources/img/icons/ETL-logo.png') }
									alt="ETL Verified Endurance"
								/>
							</div>
							<h3>Water Resistant</h3>
							<p>ETL tested to protect against water intrusion for up to 72 hours.</p>
							<Link to="/learn/buying-guide" className="arrow-link">
								Learn more about ETL testing
							</Link>
						</div>
					</div>
				</section>

				<section className="row hour-test">
					<div className="col">
						<h3 className="title">Organization and Convenience</h3>
					</div>
					<div className="callouts">
						<div className="col sm-3">
							<h3 className="sub-title">Easy To Transport</h3>
							<p>The smaller size and built in handles makes document safes portable.</p>
						</div>
						<div className="col sm-3">
							<h3 className="sub-title">Hanging File Design</h3>
							<p>Designed to hold hanging files, these safes are ideal for documents and small digital media files.</p>
						</div>
					</div>
				</section>

				<Testimonial
					imgSrc1={ require('../../resources/img/callouts/testimonial-fire-2.jpg')}
					alt1="House Fire"
					imgSrc2={ require('../../resources/img/callouts/testimonial-quote.png') }
					alt2="Quote"
					quote="My home burned completely from the roof down. I was very surprised and happy that the Sentry<sub>&reg</sub>Safe File Box survived. The box itself was destroyed, but the files inside were okay. It&rsquo;s amazing that anything survived&#33;"
					submitted="James H."
					readLink="View all SentrySafe Stories"
					link="/learn/customer-stories"
				/>

				<TotalProductCount
					link="document-safes"
					productTotal={ totalCount }
					name={ pageTitle }
				/>
				{/*<OptInPopup />*/}
			</div>
		);
	}
}	

export default branch({
	category: ['category'],
	featuredProduct: ['category', 'featuredProduct', 'products']
}, Category);


// WEBPACK FOOTER //
// ./src/pages/category/DocumentCategory.js